import { useQuery } from '@tanstack/react-query';
import { fetchShippingTransportationGroupsList } from '@views/screens/Shipment/data-provider/shipping-transportation-groups-list';

export const useGetShippingTransportationGroupsList = () => {
  return useQuery({
    queryKey: ['shipping-transportation-groups-list'],
    queryFn: () => fetchShippingTransportationGroupsList(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
